<template>
  <div class="subSuccessfully">
    <img src="@/assets/images/faceSuccessful.png" alt="">
    <p v-if="!typeName">答案已经提交成功，{{ times }}s后自动返回首页</p>
    <p v-else>系统检查到非法操作，已自动提交试卷，{{ times }}s后自动返回首页</p>
    <el-button type="primary" @click="isRouter()">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: "subSuccessfully",
  data() {
    return {
      times: 10,
      typeName: '',
      shopTime: ''
    }
  },
  mounted() {
    this.setTimes();
    this.typeName = this.$route.query.type
  },
  methods: {
    isRouter() {
      clearInterval( this.shopTime)
      this.$router.replace('/home')
    },
    setTimes() {
     this.shopTime = setInterval(() => {
        this.times --;
        if(this.times === 1) {
          this.$router.replace('/home')
          clearInterval( this.shopTime)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.subSuccessfully{width: 100%;display: flex;flex-direction: column;align-items: center;padding-top: 100px}
.subSuccessfully p{font-size: 20px;color: #333;margin: 20px 0 50px}
</style>
